import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';

// react-i18next@legacy

import en from './locales/en';
import vi from './locales/vi';

const resources = {
  en: {
    translations: en,
  },
  vi: {
    translations: vi,
  },
};

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'vi',
    fallbackLng: 'vi', // use en if detected lng is not available
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
      formatSeparator: ',',
    },

    react: {
      wait: true,
    },
  });

export default i18n;
